import _ from 'underscore';
import React from 'react';
import $ from 'jquery';
import PropTypes from 'prop-types';

import { createAsyncToken } from '@bingads-webui-universal/primitive-utilities';
import { withUiBlock } from '@bingads-webui/uiblocker';

import {
  RECOMMENDATION_TYPES,
  APPLY_SETTINGS,
  APPLY_ACTION_TYPES
} from '../consts';

export const withTrack = withAll => (WrappedComponent) => {
  class WithTrack extends React.Component {
    static propTypes = {
      dataService: PropTypes.shape({
        track: PropTypes.func,
        stopStatusPoll: PropTypes.func,
      }),
      callback: PropTypes.func,
      /**
       * HTML element that will be the target of a UI blocker
       */
      el: PropTypes.string,
      forwardedRef: PropTypes.func,
    };

    static defaultProps = {
      forwardedRef: null,
      dataService: {
        track: _.noop,
        stopStatusPoll: _.noop,
      },
      callback: _.noop,
      el: undefined,
    };

    componentWillUnmount = () => {
      this.cancel();
    };

    track = (op) => {
      this.cancel();

      const {
        dataService, el,
      } = this.props;

      let settings = null;
      if (withAll && _.contains([
        RECOMMENDATION_TYPES.DEVICE_BID_BOOST,
        RECOMMENDATION_TYPES.LOCATION_BID_BOOST], op.type) && op.applyOpportunitiesLevel) {
        settings = {
          '@odata.type': APPLY_SETTINGS.DEFAULT,
          ApplyOpportunitiesLevel: op.applyOpportunitiesLevel,
        };
      }

      const options = _.extend(
        {}, {
          withAll:
          op.userAction === APPLY_ACTION_TYPES.ACCEPT &&
          op.type === RECOMMENDATION_TYPES.IMAGE_EXTENSION ?
            false : withAll,
          closeUiBlock: withUiBlock($(el)),
        }, settings && { settings },
        _.pick(
          op,
          'type',
          'channel',
          'userInputs',
          'campaignAdGroups',
          'userAction',
          'reason',
          'context',
          'guid',
          'from',
          'handleRecommendationNotification',
          'viewDetails',
          'view',
          'showAsyncApplyModal',
          'totalRecommendationCount',
          'closeAsyncApplyModal',
          'isOptimizationScoreUsed',
          'optimizationScore'
        )
      );

      this.loadToken = createAsyncToken(dataService
        .track(options))
        .on({
          onSuccess: () => {
            this.props.callback(op);
          },
          onCancel: () => {
            dataService.stopStatusPoll();
          },
        });
    };

    cancel = () => {
      if (this.loadToken) {
        this.loadToken.cancel();
      }
    };

    render = () => {
      const rest = _.omit(this.props, 'forwardedRef');

      return (<WrappedComponent
        track={this.track}
        ref={this.props.forwardedRef}
        {...rest}
      />);
    };
  }

  return React.forwardRef((props, ref) => <WithTrack {...props} forwardedRef={ref} />);
};
